export const PAGINATION_DEFAULT_PAGE = 1
export const PAGINATION_DEFAULT_SIZE = 6
export const GALLERY_SIZE = 5
